export default "__VITE_ASSET__B64SikO2__"